export default "__VITE_ASSET__C3DDdhvw__"